import React, { useState, useEffect } from "react";
import { } from 'react-redux';
import { useTranslation } from "react-i18next";

import {
  Modal,
  Form,
  Input
} from '@lockerpm/design';

import {
  InfoCircleFilled
} from "@ant-design/icons";

import { orange } from '@ant-design/colors';

import global from "../../config/global";

const PasswordConfirmModal = (props) => {
  const { t } = useTranslation();

  const {
    visible = false,
    danger = false,
    title = '',
    okText = '',
    callingAPI = false,
    width = 360,
    onConfirm = () => { },
    onClose = () => { },
  } = props;

  const [form] = Form.useForm();
  const [checking, setChecking] = useState(false);

  const password = Form.useWatch('password', form);

  useEffect(() => {
    form.resetFields();
    setChecking(false);
  }, [visible])

  const handleConfirm = async () => {
    form.validateFields().then(async () => {
      setChecking(true)
      const keyHash = await global.jsCore.cryptoService.hashPassword(password, null)
      const storedKeyHash = await global.jsCore.cryptoService.getKeyHash()
      if (!!storedKeyHash && !!keyHash && storedKeyHash == keyHash) {
        onConfirm(password);
      } else {
        global.pushError({ message: t('validation.invalid', { name: t('lock.master_password') }) })
      }
      setChecking(false);
    })
  }

  return (
    <Modal
      className="confirm-password"
      title={
        <div className="flex items-center">
          <InfoCircleFilled style={{
            color: orange[5]
          }} />
          <p className="ml-2">
            {title}
          </p>
        </div>
      }
      open={visible}
      width={width}
      okText={okText}
      onOk={() => handleConfirm()}
      onCancel={() => onClose()}
      okButtonProps={{
        loading: checking || callingAPI,
        disabled: !password,
        danger: danger
      }}
      cancelButtonProps={{
        disabled: checking || callingAPI
      }}
    >
      <div className="mb-2">
        {t('password_confirm.confirm_note')}
      </div>
      <Form
        form={form}
        onFinish={handleConfirm}
      >
        <Form.Item
          name={'password'}
          rules={[
            global.rules.REQUIRED(t('auth_pages.password')),
          ]}
        >
          <Input.Password
            autoFocus={true}
            placeholder={t('placeholder.enter')}
            disabled={checking || callingAPI}
          />
        </Form.Item>
      </Form>
    </Modal>
  );
}

export default PasswordConfirmModal;